// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_errorContainer__xceEP {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f0f7ff 0%, #ffffff 100%);
  padding: 20px;
}

.styles_errorCard__u9ftm {
  background: white;
  border-radius: 24px;
  padding: 40px;
  max-width: 450px;
  width: 100%;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.styles_logo__FSuiM {
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
}

.styles_title__eADDY {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.styles_message__IgrOB {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0 0 32px 0;
}

.styles_actions__ZLWZU {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.styles_primaryButton__IaLvA {
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 500;
  color: white;
  background: #2563eb;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.styles_primaryButton__IaLvA:hover {
  background: #1d4ed8;
}

.styles_secondaryButton__EPrQh {
  width: 100%;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 500;
  color: #2563eb;
  background: transparent;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.styles_secondaryButton__EPrQh:hover {
  background: #f9fafb;
  border-color: #d1d5db;
}

.styles_errorDetails__m8wtJ {
  margin-top: 24px;
  text-align: left;
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px;
}
.styles_errorDetails__m8wtJ summary {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  margin-bottom: 8px;
}
.styles_errorDetails__m8wtJ pre {
  font-size: 12px;
  color: #dc2626;
  background: #fef2f2;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 8px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/error-boundary/styles.module.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6DAAA;EACA,aAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAAF;AAEE;EACE,mBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AADF;AAGE;EACE,mBAAA;EACA,qBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;AAHJ","sourcesContent":["@import \"mixins\";\n.errorContainer {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, #f0f7ff 0%, #ffffff 100%);\n  padding: 20px;\n}\n\n.errorCard {\n  background: white;\n  border-radius: 24px;\n  padding: 40px;\n  max-width: 450px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.logo {\n  width: 64px;\n  height: 64px;\n  margin-bottom: 24px;\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n  margin: 0 0 12px 0;\n}\n\n.message {\n  font-size: 16px;\n  color: #666;\n  line-height: 1.5;\n  margin: 0 0 32px 0;\n}\n\n.actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.primaryButton {\n  width: 100%;\n  padding: 14px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: white;\n  background: #2563eb;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n\n  &:hover {\n    background: #1d4ed8;\n  }\n}\n\n.secondaryButton {\n  width: 100%;\n  padding: 14px 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #2563eb;\n  background: transparent;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background: #f9fafb;\n    border-color: #d1d5db;\n  }\n}\n\n.errorDetails {\n  margin-top: 24px;\n  text-align: left;\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 12px;\n\n  summary {\n    font-size: 14px;\n    font-weight: 500;\n    color: #666;\n    cursor: pointer;\n    margin-bottom: 8px;\n  }\n\n  pre {\n    font-size: 12px;\n    color: #dc2626;\n    background: #fef2f2;\n    padding: 12px;\n    border-radius: 6px;\n    overflow-x: auto;\n    white-space: pre-wrap;\n    word-break: break-word;\n    margin: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorContainer": `styles_errorContainer__xceEP`,
	"errorCard": `styles_errorCard__u9ftm`,
	"logo": `styles_logo__FSuiM`,
	"title": `styles_title__eADDY`,
	"message": `styles_message__IgrOB`,
	"actions": `styles_actions__ZLWZU`,
	"primaryButton": `styles_primaryButton__IaLvA`,
	"secondaryButton": `styles_secondaryButton__EPrQh`,
	"errorDetails": `styles_errorDetails__m8wtJ`
};
export default ___CSS_LOADER_EXPORT___;
